export default {
  title: 'Sådan fungerer behandlingsgebyrer',
  how_it_works:
    'Stripe opkræver sit gebyr hos din platform for hver onlinebetaling, som dine restauranter modtager. Det behandlingsgebyr, du fastsætter, er det, restauranten betaler for den betaling. Hvis det er højere end Stripes gebyr, beholder du forskellen som din margin. Hvis det er lavere, eller du ikke fastsætter nogen, betaler du selv forskellen.',
  stripe_rates_link: 'Se Stripes standardsatser',
  example: {
    intro:
      'Eksempel: en ordre på {{total}} betalt med kort. Stripe opkræver din platform {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Din sats {{rate}}: restauranten betaler {{fee}}, du beholder {{difference}}.',
    below: 'Din sats {{rate}}: restauranten betaler {{fee}}, du betaler forskellen på {{difference}}.',
    none: 'Ingen sats (0 % margin): restauranten betaler intet, du betaler hele {{stripe_fee}}.',
    disclaimer:
      'Stripes gebyr her er dets standardkortsats i EØS, kun som illustration. Dit faktiske gebyr afhænger af kortet, dets land og din Stripe-prisplan.',
  },
};
